module.exports = __webpack_public_path__ + "img/1_020.5a3ef81f.jpg";